import Phaser from 'phaser';
// import config from '../config';
import config from '../config';
import pageParams from '../pageParams';
import ballData from '../data/ballData';

// const bounce = 0.7;
// const drag = 30;

class Ball extends Phaser.GameObjects.Image {
    constructor(scene, x, y, diameter, imageName) {
        super(scene, (x + diameter / 2), (y + diameter / 2) - diameter, imageName);

        const scale = diameter / this.width;

        this.velocityScreenFactor = pageParams.clientWidth / 320;
        this.diameter = diameter;
        // this.scale = scale;

        this.setScale(scale, scale);
        this.setDepth(1);
        this.setAlpha(0);

        // this.startX = x + diameter / 2;
        this.startY = y + diameter / 2;

        this.scene = scene;

        scene.add.existing(this);
    }

    show() {
        this.scene.tweens.add({
            targets: this,
            y: this.startY,
            alpha: 1,
            ease: 'Cubic',
            duration: 500,
            onComplete: () => {
                this.scene.physics.add.existing(this);
                // this.body.setCollideWorldBounds(true);
                this.body.setSize(this.width, this.height);
                this.body.isCircle = true;
                // this.body.setCircle((this.diameter * (2 - this.scale)) / 2);
                this.body.setMaxVelocity(100);
                this.scene.isMoveAbility = true;
            },
        });
    }

    push(x, y) {
        // if (Math.abs(x) > Math.abs(y)) {
        //     this.body.setVelocity(x * this.velocityScreenFactor, 0);
        // } else {
        //     this.body.setVelocity(0, y * this.velocityScreenFactor);
        // }
        this.body.setVelocity(this.velocityScreenFactor * x, this.velocityScreenFactor * y);
        this.body.setDrag(0);
        // this.body.bounce.set(0);
    }

    loose() {
        this.body.setDrag(0);
        this.body.setVelocity(0);
        // this.body.setDrag(drag);
        // this.body.bounce.set(bounce);
    }

    checkHold(pointX, pointY) {
        const { x: positionX, y: positionY } = this.body.position;
        return pointX >= positionX
            && pointX <= positionX + this.diameter
            && pointY >= positionY
            && pointY <= positionY + this.diameter;
    }

    hold(x, y, pointDiameter, callback) {
        const holdAnimationDuration = ((pointDiameter / 2 + this.diameter / 2) / 100) * 1000;

        this.body.setVelocity(0);

        this.scene.tweens.add({
            targets: this,
            x,
            y,
            ease: 'Linear',
            duration: holdAnimationDuration,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }

    getSitePosition(x, y) {
        this.setAlpha(0);
        this.setX(pageParams.offsetLeft + x + this.diameter);
        this.setY(2 * pageParams.offsetTop + y);
    }


    researchPageAnimation(callback) {
        const { siteCoord: { research: { x, y } } } = ballData[pageParams.screenSize];

        this.getSitePosition(x - 100, y);

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            x: pageParams.offsetLeft + x + this.diameter,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.ball,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }

    designPageAnimation(callback) {
        const { siteCoord: { design: { x, y } } } = ballData[pageParams.screenSize];

        this.getSitePosition(x, y + 100 - this.diameter);

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: 2 * pageParams.offsetTop + y - this.diameter,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.ball,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }


    launchPageAnimation(callback) {
        const { siteCoord: { launch: { x, y } } } = ballData[pageParams.screenSize];

        this.getSitePosition(x, y - 100 + this.diameter);

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: 2 * pageParams.offsetTop + y + this.diameter,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.ball,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }
}

export default Ball;
